import { Button, Card, CardBody, CardFooter, Select, SelectItem } from "@heroui/react"
import { ENUM_ACTYPE, ENUM_INPUT_TYPE, apiRoute, linksUrl } from "../../constants/enum"
import { useEffect, useState } from "react"
import NextInputBox from "../../components/InputBox"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"


const Transport = () => {
    const { compCode } = useSelector((state) => state.company)
    const { partyAcId } = useSelector((state) => state.account)
    let { user } = useSelector((state) => state.auth)
    let [isUpdate, setIsUpdate] = useState(false);

    const { data: itemtrans = [] } = useFetchWithBody({
        url: apiRoute.account.fetchAcByType,
        queryKey: "getAcTypeTrasnport",
        inputData: {
            comp_code: compCode.join(","),
            ac_type: ENUM_ACTYPE.Transapoter
        }
    })

    const onSuccessGetTrasport = (data) => {
        
        if (data && data.length > 0) {
            if (data && data.length > 0) {
                setIsUpdate(true);
                setFormData({
                    transportID: data[0].TAC_ID
                })
            }
        }
        else {
            setIsUpdate(false);
        }

    }
    const { data = [], mutate: getTrasport } = usePost({
        url: apiRoute.account.fetchTransport,
        queryKey: "getTrasport",
        onSuccessTasks: onSuccessGetTrasport


    })
    const formField = {
        transportID: "transportID"
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        acc[key] = "";
        return acc;
    }, {});

    let [formData, setFormData] = useState({
        ...emptyFormField
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev, [name]: value
        })
        )
    }
    const handleSelectionChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev, [name]: value
        })
        )
    }

    useEffect(() => {
        if (data.length == 0) {
            if (partyAcId && partyAcId !== "") {
                getTrasport({
                    data: {
                        comp_code: compCode.join(","),
                        pac_id: partyAcId
                    }
                })

            }
        }
    }, [])

    const inputBoxes = {
        Row1: [
            {
                name: formField.transportID,
                placeholder: "Trasporter",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: itemtrans,
                isrequired: true,
                itemkey: "AC_ID",
                itemvalue: "AC_DESC"
            },

        ],

    }


    const onSuccessTasks = (data) => {
        if (data) {
            toast.success(isUpdate ? "Trasporter Updated Successfully " : "Trasporter Assigned Successfully ", {
                position: "top-center"
            })
        }
    }
    const resetValues = () => {
        setFormData({})
    }
    const {isPending, mutate: funInsert } = usePost({
        url: apiRoute.account.addTransport,
        queryKey: "insertTrasport",
        onSuccessTasks,
        resetValues
    })
    
    const handleSubmit = (e) => {
        e.preventDefault();
        funInsert({
            data: {
                tac_id: formData.transportID,
                comp_code: compCode.join(","),
                pac_id: partyAcId,
                user_id:user.username,
                rec_status: isUpdate ? 1 : 2
            }

        })
    }

    return (
        <div>
            <Card shadow="sm" radius="sm" className="mb-3 h-full">
                <form onSubmit={handleSubmit}>
                    <CardBody className="p-2">

                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    <div className="flex  items-center gap-2 mb-5" key={ind} >
                                        {inputBoxes[key].map((item, index) => item.type == ENUM_INPUT_TYPE.select ? (
                                            <Select
                                                name={item.name}
                                                size="sm"
                                                label={item.placeholder}
                                                labelPlacement="outside"
                                                placeholder="---select---"
                                                selectionMode="single"
                                                isRequired={item.isrequired}
                                                items={item.data ? item.data : []}
                                                onChange={handleSelectionChange}
                                                selectedKeys={[String(formData[item.name])]}
                                            >
                                                {(list) => {
                                                    return (
                                                        <SelectItem key={list[item.itemkey]}>
                                                            {list[item.itemvalue]}
                                                        </SelectItem>)

                                                }}
                                            </Select>

                                        ) : (
                                            <NextInputBox
                                                placeholder={item.placeholder}
                                                value={formData[item.name]}
                                                required={item.isrequired}
                                                name={item.name}
                                                type={item.type}
                                                size={item.size}
                                                label={item.placeholder}
                                                labelPlacement="outside"
                                                onChange={handleInputChange}
                                            />))}
                                    </div>
                                </div>
                            ))
                        }
                        <div>

                            <CardFooter className="flex justify-center">
                                <Button color="primary" type="submit" isLoading={isPending} >
                                    Submit
                                </Button>

                            </CardFooter>
                        </div>
                    </CardBody>
                </form>

            </Card>
        </div>
    )
}
export default Transport